import React, { useReducer } from 'react';
import UsuarioReducer from './UsuarioReducer';
import UsuarioContext from './UsuarioContext';

const UsuarioState = (props) => {

 const estadoInicial = {
  objUsuario: {
    // apellido: "",
    // email: "",
    // fotoUrl: "",
    // id: "",
    // nombre: "",
    // rol: 0,
    // telefono: ""
  }
//   contador: 1
 }
 
 

 const [state, dispatch] = useReducer(UsuarioReducer, estadoInicial);

 const setObjUsuario = (nuevoValor) => {

  dispatch({
   type: "CAMBIAR_OBJUSUARIO",
   payload: nuevoValor
  });

 }


 return (
  <UsuarioContext.Provider
   value={{
    objUsuario: state.objUsuario,
    // contador: state.contador,
    setObjUsuario: setObjUsuario
   }}>
   {props.children}

  </UsuarioContext.Provider>
 )
}


export default UsuarioState;